(function () {
  var arabicDigits = {
    '٠': '0', '١': '1', '٢': '2', '٣': '3', '٤': '4',
    '٥': '5', '٦': '6', '٧': '7', '٨': '8', '٩': '9',
    '۰': '0', '۱': '1', '۲': '2', '۳': '3', '۴': '4',
    '۵': '5', '۶': '6', '۷': '7', '۸': '8', '۹': '9'
  };
  var digitPattern = /[٠-٩۰-۹]/g;
  var ignoredTags = /^(SCRIPT|STYLE|NOSCRIPT|TEXTAREA|TEMPLATE)$/;

  function latinize(value) {
    return value.replace(digitPattern, function (digit) { return arabicDigits[digit]; });
  }

  function convertTextNode(node) {
    if (!node || !node.nodeValue || !digitPattern.test(node.nodeValue)) return;
    digitPattern.lastIndex = 0;
    node.nodeValue = latinize(node.nodeValue);
  }

  function convertTree(root) {
    if (!root) return;
    if (root.nodeType === Node.TEXT_NODE) {
      convertTextNode(root);
      return;
    }
    if (root.nodeType !== Node.ELEMENT_NODE && root.nodeType !== Node.DOCUMENT_FRAGMENT_NODE) return;
    if (root.tagName && ignoredTags.test(root.tagName)) return;

    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        var parent = node.parentElement;
        return parent && !ignoredTags.test(parent.tagName)
          ? NodeFilter.FILTER_ACCEPT
          : NodeFilter.FILTER_REJECT;
      }
    });
    var textNode;
    while ((textNode = walker.nextNode())) convertTextNode(textNode);
  }

  function start() {
    convertTree(document.body);
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'characterData') convertTextNode(mutation.target);
        mutation.addedNodes.forEach(convertTree);
      });
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
